import React from "react";

import CircleIcon from "../svgIcons/CirclIcon";
import SadIcon from "../svgIcons/SadIcon";
import SuccessIcon from "../svgIcons/SuccessIcon";
import WarningIcon from "../svgIcons/WarningIcon";

const StatusIcon = ({ status, fill }) => {
  if (status === "loading") {
    return <CircleIcon fill={fill || "#41ccbb"} />;
  }
  if (status === "warning") {
    return <SadIcon fill="rgb(214, 116, 40)" />;
  }
  if (status === "error") {
    return <WarningIcon fill={fill || "rgb(214, 116, 40)"} />;
  }
  if (status === "success") {
    return <SuccessIcon fill={fill || "#41ccbb"} />;
  }
};

export default StatusIcon;
